// ============================================
// Connection Speed Hook - Type-Safe
// ============================================

import { useState, useEffect } from 'react';
import { APP_CONFIG } from '../config/constants';

interface ConnectionSpeed {
    isFast: boolean;
    tested: boolean;
}

// Cache result globally
let cachedSpeedResult: ConnectionSpeed | null = null;

/**
 * Hook to detect connection speed
 * Runs once and caches result
 */
export const useConnectionSpeed = (): ConnectionSpeed => {
    const [result, setResult] = useState<ConnectionSpeed>(() =>
        cachedSpeedResult || { isFast: false, tested: false }
    );

    useEffect(() => {
        // If already tested and cached, skip
        if (cachedSpeedResult?.tested) {
            setResult(cachedSpeedResult);
            return;
        }

        const testSpeed = async () => {
            try {
                const startTime = performance.now();
                await fetch('https://image.tmdb.org/t/p/w92/wwemzKWzjKYJFfCeiB57q3r4Bcm.png', {
                    method: 'HEAD',
                    cache: 'no-cache',
                });
                const duration = performance.now() - startTime;
                cachedSpeedResult = {
                    isFast: duration < APP_CONFIG.connectionTestTimeout,
                    tested: true
                };
            } catch {
                cachedSpeedResult = { isFast: false, tested: true };
            }
            setResult(cachedSpeedResult);
        };

        testSpeed();
    }, []);

    return result;
};
